/* eslint-disable react/prop-types */
import AddAlert from "@material-ui/icons/AddAlert";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Loader from "components/Loader";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Constants from "../variables/Constants";
import FormControl from "@material-ui/core/FormControl";
import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
const classes = makeStyles(styles);
let fd = new FormData();
let ProgressBar = (props) => {
  return (
    <div className="progress-bar">
      <Filler percentage={props.percentage} />
    </div>
  );
};
let Filler = (props) => {
  return (
    <div className="filler" style={{ width: `${props.percentage}%` }}></div>
  );
};
class UpdateSubjectFilter extends Component {
  state = {
    title: "",
    category_id: "",
    img: "",
    progress: 0,
    mediaProgress: false,
    id: "",
    categories: [],
    redirect: false,
    notification: false,
    loading: false,
    description: "",

    status: "",
    is_deleted: "",
    id: 0,
    subjectData: {},
    subject_id: 0,
    Subjects: [],
  };
  componentDidMount() {
    this.getSubjects();
    let subjectData = this.props.location.state.subjectData;
    console.log(subjectData);
    this.setState(
      {
        subjectData,
        subject_id: subjectData.subject_id,
        description: subjectData.description,
        title: subjectData.title,
        status: subjectData.status,
        is_deleted: subjectData.is_deleted,
      },
      () => {
        console.log(this.state.title);
      }
    );
  }
  getSubjects = () => {
    axios
      .get(
        "https://admin.akclasses.in/api/subject_master/paginate_index?per_page=100" +
          "&type=Course"
      )
      .then((res) => {
        console.log("subjects", res);
        this.setState(
          {
            Subjects: res.data.data,
          },
          () => {
            console.log(this.state.Subjects);
          }
        );
      });
  };
  handleFile = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] });
  };
  handleSubmit = (e) => {
    this.setState({
      loading: true,
    });
    e.preventDefault();
    const payload = {
      subject_filter_id: this.state.subject_id,
      description: this.state.description,
      title: this.state.title,
      status: this.state.status,
      is_deleted: this.state.is_deleted,
    };
    console.log(payload);
    axios
      .post(Constants.postUrls.updateSubjectFilter, payload, {
        onUploadProgress: (progressEvent) => {
          this.setState({
            progress: Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            ),
            mediaProgress: true,
          });
          if (this.state.progress === 100) {
            this.setState({ mediaProgress: false });
          }
        },
      })
      .then(() => {
        //console.log(resp);
        setTimeout(() => {
          this.setState({
            redirect: true,
          });
        }, 1000);
        this.setState({
          notification: true,
          loading: false,
        });
      });
  };
  render() {
    if (this.state.redirect) {
      return <Redirect to={"/admin/subjectsFilter"} />;
    } else {
      return (
        <div>
          <GridContainer>
            {this.state.notification ? (
              <div style={{ position: "relative", left: "600px" }}>
                <SnackbarContent
                  message={"Sub Category Updated!"}
                  icon={AddAlert}
                  color="success"
                />
              </div>
            ) : null}
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="danger">
                    <EditIcon />
                  </CardIcon>
                  <h4 style={{ color: "black" }}>Update Subject Filter</h4>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.handleSubmit}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <FormControl
                          style={{ marginTop: "12px" }}
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                          >
                            Subject
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu,
                            }}
                            classes={{
                              select: classes.select,
                            }}
                            required={true}
                            value={this.state.subject_id}
                            inputProps={{
                              required: true,
                              name: "subejct_id",
                              id: "simple-select",
                              onChange: (e) => {
                                this.setState(
                                  {
                                    subject_id: e.target.value,

                                    aAlert: false,
                                  },
                                  () => {
                                    console.log(this.state.subject_id);
                                  }
                                );
                              },
                            }}
                          >
                            {this.state.Subjects.map((v, i) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                                key={i}
                                value={v.id}
                              >
                                {v.title}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {this.state.aAlert ? (
                          <div>
                            <span style={{ color: "red" }}>*required</span>
                          </div>
                        ) : null}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Title"
                          id="float"
                          inputProps={{
                            required: true,
                            value: this.state.title,
                            onChange: (e) =>
                              this.setState({ title: e.target.value }),
                          }}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Description"
                          id="float"
                          inputProps={{
                            required: true,
                            value: this.state.description,
                            onChange: (e) =>
                              this.setState({ description: e.target.value }),
                          }}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <Button className="" color="warning" type="submit">
                          {this.state.loading ? (
                            <Loader />
                          ) : (
                            "Update Subject Filter"
                          )}
                        </Button>
                        <Link
                          to={{
                            pathname: "/admin/subjectsFilter",
                          }}
                        >
                          <Button className="btn-round" color="danger">
                            Cancel
                          </Button>
                        </Link>
                      </GridItem>
                    </GridContainer>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }
  }
}

export default UpdateSubjectFilter;
